export default {
	wrap: {
		padding: '20px 15px',
		background: '#fff',
		borderTop: '1px solid #e8e8e8',
		margin: '0px -15px'
	},
	heading: {
		marginTop: '12px',
		'& span': {
			display: 'inline-block',
			paddingRight: '12px',
			color: 'rgba(0,0,0,0.85)',
			fontWeight: 'bold',
			fontSize: '16px',
			lineHeight: '1.4'
		}
	},
	handCursor: {
		cursor: 'pointer !impostant'
	}
};
